"use client";

import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const towns = [{
  name: "Durham, NC",
  path: "/PestControlInDurhamNCPage"
}, {
  name: "Raleigh, NC",
  path: "/RaleighNCPestControlPage"
}, {
  name: "Cary, NC",
  path: "/CaryNCPestControlPage"
}, {
  name: "Chapel Hill, NC",
  path: "/PestControlInChapelHillNCPage"
}, {
  name: "Wake Forest, NC",
  path: "/PestControlInWakeForestNCPage"
}, {
  name: "Morrisville, NC",
  path: "/PestControlInMorrisvilleNCPage"
}, {
  name: "Hillsborough, NC",
  path: "/PestControlInHillsboroughNCPage"
}];
export default function WhereWeWork() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="where-we-work" id="where-we-work" className="bg-background text-foreground py-20 md:py-28 border-b border-border">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-8 bg-primary" />
            <span className="font-mono text-xs uppercase tracking-widest text-primary">
              Local Service Coverage
            </span>
            <span className="block h-px w-8 bg-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Where We Work
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-sans">
            Attic to Basement Pest Control is based right here in Durham, NC and proudly serves homeowners across the Triangle.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {towns.map((town, index) => <Link key={index} data-index={index} to={town.path} className="group border border-border bg-card rounded-md p-6 shadow-sm hover:border-primary/50 hover:shadow-md transition-all duration-200 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="size-9 rounded-md bg-primary/10 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-200">
                  <MapPin size={18} />
                </div>
                <h3 className="font-default font-semibold text-foreground group-hover:text-primary transition-colors duration-200">
                  {town.name}
                </h3>
              </div>
              <ArrowRight size={16} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
            </Link>)}

          <div className="border border-dashed border-border bg-muted/20 rounded-md p-6 flex items-center">
            <p className="text-xs font-mono uppercase tracking-wider text-muted-foreground">
              Durham-Based • Serving The Greater Triangle
            </p>
          </div>
        </div>
      </div>
    </section>;
}